import { render } from "./TextComp.vue?vue&type=template&id=580f188b&scoped=true"
import script from "./TextComp.vue?vue&type=script&lang=js"
export * from "./TextComp.vue?vue&type=script&lang=js"

import "./TextComp.vue?vue&type=style&index=0&id=580f188b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580f188b"]])

export default __exports__